/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ActionType;
(function (ActionType) {
    ActionType["HIRING_FACEBOOK"] = "HIRING_FACEBOOK";
    ActionType["ORGANIC_FACEBOOK"] = "ORGANIC_FACEBOOK";
    ActionType["ORGANIC_LINKEDIN"] = "ORGANIC_LINKEDIN";
    ActionType["ORGANIC_INSTAGRAM"] = "ORGANIC_INSTAGRAM";
    ActionType["ORGANIC_TWITTER"] = "ORGANIC_TWITTER";
    ActionType["ORGANIC_TIKTOK"] = "ORGANIC_TIKTOK";
    ActionType["JOB_DESC"] = "JOB_DESC";
    ActionType["JOB_TITLE_ALT"] = "JOB_TITLE_ALT";
    ActionType["GOOGLE_AD"] = "GOOGLE_AD";
    ActionType["HIRING_TEXT"] = "HIRING_TEXT";
    ActionType["REFERRAL_TEXT"] = "REFERRAL_TEXT";
    ActionType["FOLLOWUP_TEXT"] = "FOLLOWUP_TEXT";
    ActionType["DM_LINKEDIN"] = "DM_LINKEDIN";
    ActionType["HIRING_EMAIL"] = "HIRING_EMAIL";
    ActionType["FOLLOWUP_EMAIL"] = "FOLLOWUP_EMAIL";
    ActionType["FOLLOWUP_VOICEMAIL"] = "FOLLOWUP_VOICEMAIL";
    ActionType["INTERVIEW_QUESTIONS"] = "INTERVIEW_QUESTIONS";
})(ActionType || (ActionType = {}));
